import React, { useState, useEffect, useContext } from 'react';

import PerformanceCoverage from './PerformanceCoverage';
import PerformanceBreakdown from './PerformanceBreakdown';
import AsLoading from '../../generic/AsLoading';
import { PerformanceContext } from '../../../contexts/PerformanceContext';

// ASSP-7733 Add financialStats for FigureCards
//
const Performance = ({ campaign, staticData }) => {
    const {
        loadingData,
        filters,
        setFilters,
        financialStats,
        setFinancialStats,
        performanceData,
        setPerformanceData,
        dayPartTable,
        setDayPartTable,
        deliveryTable,
        setDeliveryTable,
        dayParts,
        setDayparts,
        stations,
        setStations,
        scriptFactors,
        setScriptFactors,
        spotTypes,
        setSpotTypes,
        airtimeBursts,
        setAirtimeBursts,
        properties,
        setProperties,
        versions,
        setVersions,
        demographics,
        setDemographics,
        surveys,
        setSurveys,
        setCampaign
    } = useContext(PerformanceContext);

    const mounted = false;

    // const goFilter = async () => {
    //    if (dummy_order_data?.hasOwnProperty('id')) {
    //        try {
    //            const data = await FilterCustomReport({
    //                id: 'campaignName',
    //                interval: {
    //                    from: startDate,
    //                    to: endDate
    //                },
    //                limit: 20
    //            });
    //            // setAllQueryCampaigns(data?.data?.map((d) => { return { ...d, name: d?.display } }))
    //            // setQueryCampaigns(data?.data?.map((d) => { return { ...d, name: d?.display } }))
    //        } catch (err) {
    //            console.log(err)
    //        }
    //    }
    // }
    const toTime = (v) => {
        var h = Math.floor(v / 3600);
        var m = Math.floor((v - h * 3600) / 60);
        return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m);
    };
    useEffect(() => {
        setCampaign(campaign);
    }, [campaign?.id]);

    // useEffect(() => {
    //    // dummy data
    //    GetOrderPerformance().then((data) => {
    //        setPerformaceStats({ ...data, data: data?.data?.map((d, i) => { return { data: d?.data, key: d?.key, total: d?.total, impressions: d?.total?.impressions, advertiserName: d?.total?.advertiserName, startTime: moment(d?.total?.__time?.start)?.format('MMM DD') } })?.reverse() });
    //    }) .catch();
    // }, []);

    // useEffect(() => {
    //     mounted = true;
    //     goFilter();
    //     return () => {
    //         mounted = false;
    //     };
    // }, [dummy_order_data?.id]);
    const burstOrPropertyChange = (bp) => {
        if (bp.type === 1) {
            filters.propertySelectionId = bp.id;
        } else if (bp.type === 2) {
            filters.campaignBurstId = bp.id;
        } else {
            filters.propertySelectionId = '';
            filters.campaignBurstId = '';
        }
        setFilters({ ...filters });
    };
    return (
        <div
            id='CampaignPerformance'
            style={{
                display: 'grid',
                boxSizing: 'border-box',
                margin: '12px 30px',
                gap: 12
            }}
        >
            {loadingData && (
                <AsLoading
                    style={{
                        width: '100%',
                        height: '100%',
                        alignItems: 'center',
                        background: '#f7f7f7',
                        position: 'absolute',
                        top: 0,
                        left: 0
                    }}
                ></AsLoading>
            )}
            <PerformanceCoverage
                campaign={campaign}
                performanceData={performanceData}
                deliveryTable={deliveryTable}
                demographics={demographics}
                surveys={surveys}
                properties={properties}
                airtimeBursts={airtimeBursts}
                dayParts={dayParts}
                stations={stations}
                spotTypes={spotTypes}
                versions={versions}
                scriptFactors={scriptFactors}
                filters={filters}
                setFilters={setFilters}
                burstOrPropertyChange={burstOrPropertyChange}
                // order={dummy_order_data}
                // performanceStats={performanceStats}
                // queryCampaigns={queryCampaigns}
                // setQueryCampaigns={setQueryCampaigns}
                // allQueryCampaigns={allQueryCampaigns}
                // onStationChange={handleStationChange}
            />
            <PerformanceBreakdown
                campaign={campaign}
                filters={filters}
                performanceData={performanceData}
                currentStation={filters.stationId}
                dateRange={filters.dateRange}
                dayPartTable={dayPartTable}
                deliveryTable={deliveryTable}
                financialStats={financialStats}
                setFinancialStats={setFinancialStats}
                // order={dummy_order_data}
                // performanceStats={performanceStats}
            />
        </div>
    );
};

export default Performance;
